import { render, staticRenderFns } from "./LtkPostProduct.vue?vue&type=template&id=adb9e40c&scoped=true"
import script from "./LtkPostProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkPostProduct.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkPostProduct.vue?vue&type=style&index=0&id=adb9e40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb9e40c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CLtkImg: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkImg/CLtkImg.vue').default,LtkProductLike: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkProductLike.vue').default,CSkeletonLoader: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSkeletonLoader/CSkeletonLoader.vue').default,TrackProductImpression: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Track/TrackProductImpression.vue').default})
